<template>
  <CardLayout @onHrTree="onHrTree">
    <div class="card-body">

      <div class="search-wrap">
        <el-select v-model="is_internal" size="mini" clearable="" placeholder="是否内部员工" style="width: 150px">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
        <el-select v-model="group_id" size="mini" clearable="" placeholder="选择分组" style="width: 150px">
          <el-option v-for="item in groupList" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
        <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
      </div>

      <div class="table-wrap">
        <el-table v-loading="loading" class="chat-table" :data="tableData">
          <el-table-column prop="id" label="ID" align="left" width="50"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center" width="120"></el-table-column>
<!--          <el-table-column prop="openid" label="openid" align="center" width="230"></el-table-column>-->
          <el-table-column prop="phone" label="电话" align="center" width="140"></el-table-column>
          <el-table-column prop="is_internal" label="内部员工" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_internal ? 'primary' : 'info'" size="small">{{scope.row.is_internal ? '是' : '否'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="group_name" label="分组" align="center"></el-table-column>
          <el-table-column prop="department_name" label="所属部门" align="center" width="320"></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editUser(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
      </div>

      <!-- 修改窗口 -->
      <el-dialog title="会员信息" :visible.sync="dialogVisible" width="600px">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="form.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="内部成员" prop="is_internal">
            <el-select v-model="form.is_internal" placeholder="请选择">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组" prop="group_id">
            <el-select v-model="form.group_id" placeholder="选择分组">
              <el-option v-for="item in groupList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属组织" prop="group_id">
<!--            <SelectDepartment v-model="form.department_name" @change="form.department_id=$event.id;" />-->
            <SelectDepartmentCascader v-if="dialogVisible" v-model="form.department_name" @change="form.department_ids=$event.ancestor_id;" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </CardLayout>

</template>

<script>

  import { Loading } from 'element-ui';
  import { User, UserGroup } from './common.js'
  import CardLayout from "./components/CardLayout";
  import SelectDepartmentCascader from "./components/SelectDepartmentCascader";

export default {
  name: "CardUser",
  components: {SelectDepartmentCascader, CardLayout},
  data () {
    return {
      is_internal: '',
      group_id: '',
      department_id:"",
      keyword: '',
      loading: false,
      tableData: [],
      groupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      formLoading: false,
      form: {
        id: '',
        name: '',
        phone: '',
        is_internal: '',
        group_id: '',
        department_name:'',
        department_ids:""
      },
      rules: {
        // name: [
        //   { required: true, message: '请填写姓名', trigger: 'blur' },
        // ],
        phone: [
          { required: true, message: '请填写手机号码', trigger: 'blur' },
        ],
        is_internal: [
          { required: true, message: '请选择是否内部成员', trigger: 'change' },
        ],
        group_id: [
          { required: true, message: '请选择分组', trigger: 'change' },
        ],
      },
    }
  },
  created() {

    UserGroup.getList(res => {
      if(res.code == 0) {
        this.groupList = res.data
      }
    })

    this.getList()

  },
  methods: {
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      User.getList({
        keyword: this.keyword,
        is_internal: this.is_internal,
        group_id: this.group_id,
        department_id:this.department_id,
        page: this.page,
        page_size: this.pageSize
      }, res => {
        if(res.code == 0) {
          this.total = res.data.total
          this.tableData = res.data.data
        }
      })
    },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    editUser(item) {

      let data = {}
      for(let k in this.form) {
        data[k] = item[k]
      }
      this.form = data

      //console.log(this.form)

      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          User.save(data, res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })
        } else {
          return false;
        }
      });
    },
    deleteUser(item) {

      this.$confirm('此操作将删除该会员['+item.phone+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        User.delete(item.id, res => {
          this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
          if(res.code == 0) {
            this.getList()
          }
        })
      })

    },
    onHrTree(e){
      const that=this;
      that.department_id=e.id;
      that.search();
    }
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/User.vue